var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-primary-content-input",class:{ 'arrow-dark': _vm.whiteMode }},[_c('vue-slider',{ref:"Slider",staticClass:"mx-auto",staticStyle:{"max-width":"460px"},attrs:{"min":0,"max":10,"dotSize":30,"height":10,"tooltip":"never","piecewiseLabel":true,"bgStyle":{ backgroundColor: 'transparent' },"processStyle":{ backgroundColor: 'transparent' },"sliderStyle":{
      width: '0',
      height: '0',
      borderLeft: '11px solid transparent',
      borderRight: '11px solid transparent',
      borderBottom: '12px solid white',
      borderRadius: '0',
      boxShadow: 'none',
      backgroundColor: 'transparent',
      position: 'absolute',
      top: '28px',
      left: '6px',
    },"value":_vm.sValue,"labelStyle":{ position: 'absolute', top: '-25px', color: 'white', fontSize: '28px' }},on:{"callback":_vm.check,"drag-start":_vm.onDragStart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }